import {
  LBDialog,
  LBDialogContent,
  LBDialogDescription,
  LBDialogHeader,
  LBDialogTitle
} from '@linearb/buzz';
import { useSelector } from 'react-redux';
import { getSensorAuthorizationByIdSelector } from 'state/selectors/sensors-authorizations';
import useIsIntegrationHasData from './useIsIntegrationHasData';
import Loader from './Loader';
import HasDataForm from './HasDataForm';
import DeleteFooter from './DeleteFooter';
import useDeleteIntegration from './useDeleteIntegration';

const DeleteIntegrationModal = ({ integrationId, onClose }) => {
  const integration = useSelector(
    getSensorAuthorizationByIdSelector(integrationId)
  );
  const { hasData, isLoading } = useIsIntegrationHasData(integrationId);
  const { deleteIntegration } = useDeleteIntegration(integrationId);

  const onDeleteIntegration = async ({ isSoftDelete = false } = {}) => {
    await deleteIntegration({ isSoftDelete });
    onClose();
  };

  if (!integration) {
    return onClose();
  }

  return (
    <LBDialog open={!!integrationId} onOpenChange={onClose}>
      <LBDialogContent className='min-w-[45rem]'>
        <LBDialogHeader>
          <LBDialogTitle className='flex items-center'>
            Delete Integration
          </LBDialogTitle>
          <LBDialogDescription>
            Are you sure you want to delete the integration "{integration.name}
            "?
          </LBDialogDescription>
        </LBDialogHeader>
        {isLoading ? (
          <Loader />
        ) : hasData ? (
          <HasDataForm
            onDeleteWithData={onDeleteIntegration}
            onDeleteWithoutData={() =>
              onDeleteIntegration({ isSoftDelete: true })
            }
          />
        ) : (
          <DeleteFooter onDelete={onDeleteIntegration} />
        )}
      </LBDialogContent>
    </LBDialog>
  );
};

export default DeleteIntegrationModal;
